/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  ClinicalTrialTeamPageState,
  SetAddEditMemberModalOpenAction,
  SetCurrentModalAction,
  SetCurrentTeamMemberAction,
  SetSearchValueAction,
  SetUiControlSchemaAction,
} from './ClinicalTrialTeamPage.types';
import { createSliceHook, makeActionCreator, createSelector } from '../helpers';
import { StudyStatusEnum } from '@dynamika-shared/types/status';
import { uiControlSchemas } from 'src/pages/ClinicalTrial/uiControlSchemaByStatus/schemas';

const initialState: ClinicalTrialTeamPageState = {
  addEditMemberModalOpen: false,
  currentModal: undefined,
  currentTeamMember: undefined,
  searchValue: '',
  uiControlSchema: uiControlSchemas[StudyStatusEnum.draft].team,
};

const { act, actResolve, actEmpty } =
  makeActionCreator<ClinicalTrialTeamPageState>();

export const ClinicalTrialTeamPageSlice = createSlice({
  name: 'ClinicalTrialTeamPage',
  initialState,
  reducers: {
    setCurrentModal:
      actResolve<SetCurrentModalAction['payload']>('currentModal'),
    setCurrentTeamMember:
      actResolve<SetCurrentTeamMemberAction['payload']>('currentTeamMember'),
    setAddEditMemberModalOpen: actResolve<
      SetAddEditMemberModalOpenAction['payload']
    >('addEditMemberModalOpen'),
    setSearchValue: actResolve<SetSearchValueAction['payload']>('searchValue'),
    setUiControlSchema:
      actResolve<SetUiControlSchemaAction['payload']>('uiControlSchema'),
    confirmActionWithMember: actEmpty(),
    resetSearchValue: state => {
      state.searchValue = '';
    },
  },
});

export const {
  setCurrentModal,
  setCurrentTeamMember,
  setAddEditMemberModalOpen,
  setSearchValue,
  setUiControlSchema,
  confirmActionWithMember,
} = ClinicalTrialTeamPageSlice.actions;

export const actions = {
  ...ClinicalTrialTeamPageSlice.actions,
};

export const useClinicalTrialTeamPageSlice = createSliceHook(
  ClinicalTrialTeamPageSlice.name,
  actions
);

export const selectClinicalTrialTeamPageState = createSelector(
  'ClinicalTrialTeamPage'
);
